export default "__VITE_ASSET__DaWFZ_YJ__"